import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { clinic } from "@/mocks/clinic";

export default function Access() {
  const mapSrc =
    "https://maps.google.com/maps?q=%E6%9D%B1%E4%BA%AC%E9%83%BD%E6%B8%8B%E8%B0%B7%E5%8C%BA%E9%81%93%E7%8E%84%E5%9D%822-6-14&t=&z=16&ie=UTF8&iwloc=&output=embed";

  return (
    <section id="access" className="bg-background-50 py-16 md:py-24 lg:py-28">
      <div className="u-container">
        <Reveal>
          <SectionHeading en="CLINIC INFORMATION" jp="アクセス・クリニック情報" />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-8 md:mt-16 lg:grid-cols-2 lg:gap-12">
          <Reveal>
            <div className="h-full overflow-hidden rounded-lg border border-background-300/80 bg-background-50">
              <iframe
                title="渋谷美容皮膚科クリニック 地図"
                src={mapSrc}
                className="h-[340px] w-full md:h-full md:min-h-[460px]"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div className="flex h-full flex-col">
              <div className="border-t border-background-300/80 pt-7">
                <h3 className="font-heading text-xl text-foreground-950">{clinic.nameJp}</h3>
                <span className="en-eyebrow mt-2 block text-[10px] text-foreground-500">{clinic.nameEn}</span>

                <dl className="mt-8 space-y-5 text-[13px] md:text-sm">
                  <div className="flex gap-5">
                    <dt className="w-20 shrink-0 text-foreground-600">住所</dt>
                    <dd className="text-foreground-900">
                      {clinic.postal}
                      <br />
                      {clinic.address}
                    </dd>
                  </div>
                  <div className="flex gap-5">
                    <dt className="w-20 shrink-0 text-foreground-600">営業時間</dt>
                    <dd className="text-foreground-900">{clinic.hours}</dd>
                  </div>
                  <div className="flex gap-5">
                    <dt className="w-20 shrink-0 text-foreground-600">TEL</dt>
                    <dd>
                      <a href={clinic.telHref} className="text-foreground-900 underline-offset-4 hover:underline">
                        {clinic.tel}
                      </a>
                    </dd>
                  </div>
                  <div className="flex gap-5">
                    <dt className="w-20 shrink-0 text-foreground-600">アクセス</dt>
                    <dd className="text-foreground-900">{clinic.accessText}</dd>
                  </div>
                </dl>
              </div>

              <div className="mt-8 flex flex-col gap-3 sm:flex-row">
                <a
                  href={clinic.googleMapUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-950/20 bg-background-50 px-6 py-3 text-[13px] text-foreground-900 transition-colors hover:bg-secondary-100"
                >
                  <i className="ri-map-2-line text-base text-accent-700" aria-hidden />
                  Google Mapで開く
                </a>
                <a
                  href={clinic.telHref}
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-6 py-3 text-[13px] text-background-50 transition-colors hover:bg-primary-700"
                >
                  <i className="ri-phone-line text-base" aria-hidden />
                  電話する
                </a>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}